module.exports = __webpack_public_path__ + "img/globe-01.53887781.svg";